<script>
let users = [];

console.log("Head: " + firebase.auth().currentUser.email);

let refAllUserList;
let refTeachersList;

let searchQuery = '' // bound to the input field

$: usersFiltered = searchQuery ? users.filter(u => u.email && u.email.includes(searchQuery)) : users;

refAllUserList = firebase.database().ref("edulearn/users/list");
refAllUserList.on("child_added", function(snap) {
    let user = users.find(u => u.id == snap.val().id);
    if (user) {
        user = [...user, snap.val()];
        users = [...users];
    } else users = [...users, snap.val()];
});

refAllUserList.on("child_removed", function(snap) {
    users = users.filter(u => u.id != snap.val().id);
});

refTeachersList = firebase.database().ref("edulearn/rules/teachers");
refTeachersList.on("child_added", function(snap) {
    let user = users.find(u => u.id == snap.key);
    if (user) {
        user.isTeacher = true;
        users = [...users];
    } else {
        users = [...users, { id: snap.key, isTeacher: true }];
    }
});

refTeachersList.on("child_removed", function(snap) {
    let user = users.find(u => u.id == snap.key);
    if (user) {
        user.isTeacher = null;
        users = [...users];
    }
});

function setAsTeacher(user) {
    //   var r = confirm("Press a button!");
    refTeachersList.child(user.id).set(true);
}

function removeAsTeacher(user) {
  refTeachersList.child(user.id).set(null); 
  // каскадное удаление студентов у тичера
  let refStudentByTeacherList = firebase.database().ref("edulearn/rules/userbyteacher");
  let refTeacher = refStudentByTeacherList.child(user.id);
  refTeacher.set(null);
}
</script>

<style>
button.set {
    background: white;
    color: blue;
    text-decoration: underline;
    border: 0;
    font-size: 12px;
    cursor:pointer;
}
</style>

<h1>Head Teacher</h1>
<input type="text" bind:value={searchQuery} placeholder="filter"/>
<ul>
  {#each usersFiltered as user, i (user.id)}
    <li>
      <b>{user.name}</b>
      {user.email} {user.isTeacher ? 'TEACHER' : ''} {user.userScore} T: {user.unreadFromTeacher}
      S: {user.unreadFromStudent} ({user.id})
      {#if user.isTeacher}
        <button class="set" on:click={()=>{removeAsTeacher(user)}}>remove as teacher</button>
      {:else}
        <button class="set" on:click={()=>{setAsTeacher(user)}}>set as teacher</button>
      {/if}
    </li>
  {/each}
</ul>
